// Call event reporter (storage/static/js/virtual_visit/call-events.js) created by
// moderator_call_vue.html. Absent on other pages, so every helper is a no-op there.

export const callEvents = () => window.vvCallEvents || null;

export const trackCallEvent = (name, details) => {
    const reporter = callEvents();
    if (reporter) { reporter.track(name, details); }
};

export const callErrorDetails = (err) => (window.VVCallEvents ? window.VVCallEvents.errorDetails(err) : {});
